<template>
    <div class="mixin_formSubmissionProcess">
        <van-dialog
            v-model="confirmedByShow"
            title="提交确认"
            show-cancel-button
            @cancel="cancelSubmission"
            @confirm="confirmSubmission"
            class="submitPopUp"
        >
            <div class="submitPopUpContent">
                <div class="icon">
                    <img src="@/assets/images/contractApproval/icon.png" alt="">
                </div>
                <div class="info linkInfo">
                    <h4>
                        下一环节：
                        <span>{{ submitObj.link }}</span>
                    </h4>
                    <h4>
                        审批人：
                        <span>{{ submitObj.obj }}</span>
                    </h4>
                    <p>是否确认提交？</p>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            backPathName: '',
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },
            approvalData: {},
            CurrentBusinessProcess: {},
            businessInfo: {},
            businessCode: '',
            formKeyValue: '',
        };
    },
    filters: {},
    created() {},
    methods: {
        // 获取流程模板信息
        async getBusinessInstance() {
            const res = await this.getBusinessInstanceRequest(this.businessCode);
            if (res) {
                this.businessInfo = res;
                this.formData.BusinessInstanceId = res.BusinessInstanceId;
            }
        },
        // 启动流程实例
        async startBusinessInstance(callBackFn) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                ConfigBusinessId: this.businessInfo.ConfigBusiness.BusinessId,
                BusinessCode: this.businessInfo.ConfigBusiness.BusinessCode,
                BusinessName: this.businessInfo.ConfigBusiness.BusinessName,
            };
            const res = await this.startBusinessInstanceRequest(data);
            if (res) {
                this.saveFrom(callBackFn);
            }
        },
        // 记录保存过的表单数据
        async saveFrom(callBackFn) {
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                BusinessPhaseId: '',
                FormId: this.businessInfo.BusinessFormList[0].FormId,
                FormName: this.businessInfo.BusinessFormList[0].FormName,
                FormUrl: this.businessInfo.BusinessFormList[0].FormUrl,
                FormKeyName: this.businessInfo.BusinessFormList[0].FormKeyName,
                FormKeyValue: this.formKeyValue,
            };
            await this.saveFromRequest(data);
            this.getCurrentProcess(callBackFn);
        },
        // 获取当前流程环节
        async getCurrentProcess(callBackFn) {
            if ((this.formData.BusinessInstanceId || '') === '') {
                this.$toast('获取不到流程id！');
                return;
            }
            const res = await this.getCurrentProcessRequest(this.formData.BusinessInstanceId);
            if (res) {
                this.approvalData = res;
                this.getProcessData(callBackFn);
            } else {
                this.$toast('获取不到流程环节！');
            }
        },
        // 根据环节获取流程实例信息
        async getProcessData(callBackFn) {
            const res = await this.getProcessDataRequest();
            this.processData = res;
            this.CurrentBusinessProcess = res.CurrentBusinessProcess;
            if (callBackFn) {
                callBackFn();
            }
        },
        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },
        handleSubmit() {
            if (JSON.stringify(this.CurrentBusinessProcess) === '{}') {
                this.handleSave(this.toSubmission);
            } else {
                this.toSubmission();
            }
        },
        // 跳转到提交界面
        async toSubmission() {
            this.$toast.clear();
            // 获取环节数据请求
            // eslint-disable-next-line max-len
            const linkData = await this.getLinkDataRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.CurrentBusinessProcessId);
            let childrenData;
            // 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
            if (
                linkData.PhaseSubmitMode === 1
                && linkData.SubmitPhaseModel
                && linkData.SubmitPhaseModel.ApproverType === 2
                && linkData.SubmitPhaseModel.IsAllowEditApprover
            ) {
                this.approverRoleId = linkData.SubmitPhaseModel.ApproverRoleId.split(',');
                this.approverRoleName = linkData.SubmitPhaseModel.ApproverRoleName.split(',');
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    approverRoleId: this.approverRoleId,
                    approverRoleName: this.approverRoleName,
                    processData: this.processData,
                };

                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel.ApproverName;
                this.confirmedByShow = true;
            }

            if (childrenData) {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        backPathName: this.backPathName,
                    },
                });
            }
        },
        // 确认提交
        confirmSubmission() {
            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };
            this.submitAPI(data, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
        },

        // 流程提交
        async submitAPI(data, message, url) {
            await this.submitAPIRequest(url, data);
            this.$toast.success(message);
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
                params: {
                    isRefresh: true,
                },
            });
            this.$router.go(-1);
        },
        // 获取流程模板信息请求
        getBusinessInstanceRequest(code) {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/businessinstance/templateinfo/${code}`);
        },
        // 启动流程实例请求
        startBusinessInstanceRequest(data) {
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/businessinstance', data);
        },
        // 记录保存过的表单数据请求
        saveFromRequest(data) {
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/businessinstance/businessform', data);
        },
        // 获取当前流程环节请求
        getCurrentProcessRequest(BusinessInstanceId) {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/processes/transaction_model/${BusinessInstanceId}`);
        },
        // 根据环节获取流程实例信息请求
        getProcessDataRequest() {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/processes/${this.approvalData.BusinessInstanceId}/${this.approvalData.BusinessProcessId}`);
        },
        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`);
        },
        // 流程提交请求
        submitAPIRequest(url, data) {
            return this.$axios.$post(url, data);
        },
    },
};
</script>

<style lang="stylus" scoped></style>
